import React from "react";
import Info from "./Info";

const TableRowEdicion = (props) => {
    const { filaEnModoEdicion, tarjeta } = props;
    let paneles = [];

    paneles.push(
        <Info titulo={"Nombre"} descripcion={tarjeta.ClienteNombre + " " + tarjeta.ClienteApellido} />
    );

    paneles.push(
        <Info titulo={"Denominacion de la tarjeta"} descripcion={tarjeta.Denominacion}/>
    );

    paneles.push(
        <Info titulo={"Denominación  4° linea"} descripcion={tarjeta.CuartaLinea || "Sin especificar"} />
    );

    paneles.push(
        <Info titulo={"Tipo de tarjeta"} descripcion={tarjeta.TarjetaTipoDescripcion} />
    );

    let esTemporal = tarjeta.EsTarjetaTemporal ? "Es una tarjeta temporal" : "No es una tarjeta temporal";

    paneles.push(
        <Info titulo={"Es una tarjeta temporal"} descripcion={esTemporal} />
    );

    if (props.modalidadDistribucionLimiteId > 1) {
        paneles.push(
            <Info titulo={"Límite"} descripcion={props.limiteCompraCodigo + "/" + tarjeta.PorcentajeLimiteCompra + "%"} />
        );
    }

    paneles.push(
        <Info titulo={"Código de Distribución"} descripcion={tarjeta.DistribucionVisaDescripcion} />
    );

    return (
        <tr key={"table-row-edition-tarjeta-" + tarjeta.TarjetaCreditoId}>
            <td colSpan="7" className={((filaEnModoEdicion == false) ? "td-tarjetas-no-pad-border" : "td-tarjetas-no-pad")}>
                <div className={"slider-tarjetas" + ((filaEnModoEdicion == false) ? " closed" : "")}>
                    {paneles}
                </div>
            </td>
        </tr>
    )
}

export default TableRowEdicion;